export default __webpack_public_path__ + "static/media/fad-cpu.f3512348.svg";